module.exports = __webpack_public_path__ + "media/images/flags/ky-ef8e18776eff1caf6b648c5c29847b64.svg";